import { useContext, useState, useEffect } from 'react';
import { FormSelect } from 'react-bootstrap';
import { genesis_Requirement, genesis_RARITY } from '../constants';
import { StakingContext } from '../../../contexts/StakingContext';

import silver from '../assets/silver-notebook.png';
import golden from '../assets/golden-backpack.png';


export function GenesisStatus(props) {
    const { id, checked, isBsc, data, rarity, pairedPoints, pairedStatus } = props;

    if(pairedPoints > 0) return <GenesisSelection data={data} id={id} readOnly={!checked || !isBsc} />

    // if(isStaked) return <GenesisSelection data={data} readOnly/>

    // if(isStaked && checked) return <GenesisSelection id={id} />
    if(checked && isBsc) return <GenesisSelection data={data} id={id} rarity={rarity} pairedStatus={pairedStatus} />
}

export function GenesisSelection(props) {
    const { data = {}, id, rarity, pairedStatus, readOnly } = props;

    const { dispatchGenesis } = useContext(StakingContext);

    const [selectedSilver, setSelectedSilver] = useState("");
    const [selectedGolden, setSelectedGolden] = useState("");

    useEffect(() => {
        if(rarity && !pairedStatus) {
            handleSilverChanged({ target: { value: genesis_Requirement[rarity][genesis_RARITY.silver] } })
            handleGoldenChanged({ target: { value: genesis_Requirement[rarity][genesis_RARITY.golden] } })
        }
    }, [rarity, pairedStatus])

    const handleSilverChanged = (e) => {
        setSelectedSilver(e.target.value)

        const delta = parseInt(e.target.value) - (data.silver || 0)
        // only need to dispatch the delta if there is already genesis staked
        dispatchGenesis({ type: 'pairSilver', data: delta, pnft_id: id })
    }

    const handleGoldenChanged = (e) => {
        setSelectedGolden(e.target.value)

        const delta = parseInt(e.target.value) - (data.golden || 0)
        dispatchGenesis({ type: 'pairGolden', data: delta, pnft_id: id })
    }

    useEffect(() => {
        if(data?.silver) {
            setSelectedSilver(data.silver)
            setSelectedGolden(data.golden)
        }
    }, [data])

    return <div className='genesis-selection-box' style={{display: 'flex'}}>
        <div className='silver-notebooks genesis-box'>
            <img src={silver} alt="silver notebook" width={36} />
            <div>
                {readOnly
                    ? `x ${data.silver}`
                    : <FormSelect aria-label="Select" id="silver" value={selectedSilver} onChange={handleSilverChanged}>
                        {[0, 1, 2, 3, 4, 5].map((i) => 
                            <option key={i} value={i} disabled={i < data?.silver}>{i}</option>
                        )}
                    </FormSelect>
                }
            </div>
        </div>
        <div className='golden-backpacks genesis-box'>
            <img src={golden} alt="golden backpack" width={40} />
            <div>
                {readOnly
                    ? `x ${data.golden}`
                    : <FormSelect aria-label="Select" id="golden" value={selectedGolden} onChange={handleGoldenChanged}>
                        {[0, 1, 2].map((i) => 
                            <option key={i} value={i} disabled={i < data?.golden}>{i}</option>
                        )}
                    </FormSelect>
                }
            </div>
        </div>
    </div>
}